import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DashboardEnrichmentSummaryResponseDto } from 'src/app/shared/dto';

@Component({
    selector: 'app-enrichment-card',
    templateUrl: './enrichment-card.component.html',
    styleUrls: ['../../common-reporting-dashboard.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EnrichmentCardComponent {
  @Input() isLoading: boolean;
  @Input() useLargeText: boolean = false;
  @Input() set enrichmentData(value: DashboardEnrichmentSummaryResponseDto) {
    if (value) {
      this.innerEnrichmentData = value;
    }
  }

  get enrichmentData(): DashboardEnrichmentSummaryResponseDto {
    return this.innerEnrichmentData;
  }

  private innerEnrichmentData: DashboardEnrichmentSummaryResponseDto;

}
